import {
    HttpErrorResponse,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { catchError, throwError } from "rxjs";
import { SKIP_GLOBAL_TOAST } from "./http-context.token";

export const httpErrorInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
) => {
    const toast = inject(MessageService);
    const translate = inject(TranslateService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const skipToast = req.context.get(SKIP_GLOBAL_TOAST);

            if (!skipToast) {
                // const msg =
                //     (error as any)?.error?.message ||
                //     error.message ||
                //     "Unexpected error";
                const msg =
                    (error as any)?.error?.message || error.message || null;
                toast.add({
                    severity: "error",
                    summary: translate.instant(
                        "APP.ERROR.MESSAGE.HEADER.REQUEST_FAILED",
                    ), // Request Failed
                    detail: `${error.status} - ${msg || !msg.startsWith("http") ? msg : translatedCodes.includes(error.status) ? translate.instant(`APP.ERROR.MESSAGE.CODE.${error.status}`) : translate.instant("APP.ERROR.MESSAGE.DEFAULT.UNEXPECTED_ERROR")}`,
                    life: 4000,
                });
            }

            return throwError(() => error);
        }),
    );
};

const translatedCodes = [
    400, 401, 402, 403, 404, 405, 408, 409, 410, 413, 415, 416, 418, 422, 423,
    424, 425, 426, 428, 429, 500, 501, 502, 503, 504, 505, 507, 508, 510, 511,
];
